import { Component, OnInit, Inject } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { FormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { MatDialog } from '@angular/material/dialog';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import saveAs from 'file-saver';
import { DataService } from 'src/app/Common/data.service';

export interface DialogData {
  ID: string;
  AttachmentFor: string;
  StatusID: string;
  LocalAttachments: any[];
}

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  AttachmentsGroup: any;
  file: File;
  formData: FormData = new FormData();
  LocalAttachments: any;
  stringArray: any;
  IsApproved: boolean;
  IFileUpload: File;
  attachmentList: any[] = [];
  IsButtonHideAtt = true;

  constructor(public dialogRef: MatDialogRef<FileUploadComponent>,
    private _dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public _data: DialogData, private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService,
    private _dialog: MatDialog,
    private status: HTTPStatus) {

  }

  ngOnInit() {
    this.IsApproved = false;
    this.AttachmentsGroup = [];
    this.stringArray = [];
    if (this._data.AttachmentFor == "ServiceRequest") {
      this.GetAttachmentDetailByID(this._data.ID);
    }
    if (String(this._data.StatusID) == "4" || String(this._data.StatusID) == "5") {
      this.IsButtonHideAtt = false;
    }
    this.LocalAttachments = this._data.LocalAttachments;
  }

  onNoClick(): void {
    this.dialogRef.close(this.LocalAttachments);
  }
  onfilechange(event) {
    this.IFileUpload = event;
  }
  UploadAttachment(e) {
    debugger;
    if (e == null || e == undefined) {
      alert('Please choose file.')
      return;
    } else {
      this.formData = new FormData();
      if (e.target.files.length > 0) {
        const maxLength = 1024 * 1024 * 10;
        const fileList: FileList = e.target.files;
        const file: File = fileList[0];
        const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (fileExtension.toLowerCase() === 'docx' || fileExtension.toLowerCase() === 'doc'
          || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'zip'
          || fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx' || fileExtension.toLowerCase() === 'jpg'
          || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'png'
          || fileExtension.toLowerCase() === 'msg') {
          if (e.target.files[0].size > maxLength) {
            alert('File size cannot be more than 10 MB.');
            e.target.value = '';
            return;
          }
          this.formData.append('Attachments', file, file.name);
          this.formData.append('KeyID', this._data.ID);
          this.formData.append('AttachmentFor', this._data.AttachmentFor);
          this._commonService.UploadAttachment(this.formData).subscribe(data => {

            if (this._data.AttachmentFor == "Mailer") {
              if (this.LocalAttachments != undefined) {
                for (let item of this.LocalAttachments) {
                  this.attachmentList.push(item);
                }
              }
              this.attachmentList.push(data);
              this.LocalAttachments = this.attachmentList;
              this.dialogRef.close(this.attachmentList);
            }
            else {
              this.LocalAttachments = data;
              this.IFileUpload = null;
            }
          },
            (error) => { },
            () => { });
        } else {
          alert('Please browse valid file extension.');
          e.target.value = '';
        }
      }
    }
  }

  DeleteAttachment() {
    if (confirm('Are you sure! You want to delete the attachment?')) {
      if (this.attachmentList.length > 0) {
        this._commonService.DeleteAttahment(this.attachmentList).subscribe(data => {
          this.GetAttachmentDetailByID(this._data.ID)
        });
      }
    }
  }
  CheckChange(event, value) {
    if (event == true) {
      this.attachmentList.push({ AttachmentId: value });
    }
    else {
      this.attachmentList = this.attachmentList.filter(res => res.AttachmentId !== value);
    }
  }
  DownloadFile(attachmentData) {
    const downloadURL = 'Attachment/DownLoadFile';
    this._dataService.PostDownload(downloadURL, attachmentData).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, attachmentData.AttachmentName);
    });
  }
  GetAttachmentDetailByID(ID: string) {
    this._commonService.GetAttachmentDetailByID(ID).subscribe(data => {
      this.LocalAttachments = data;
    }, (error) => {
      // this.status.setHttpStatus(false);
      this.error.handleError(error);
    });
  }
}
